import i18n from 'i18next';
import * as Yup from 'yup';

export const CreateWorkstationSchema = (t: typeof i18n.t) =>
  Yup.object().shape({
    name: Yup.string().min(2, t('Too Short!')).max(50, t('Too Long!')).required(t('Name is required')),
  });
